<template>
  <v-btn
    icon
    :color="isMobile() ? 'white' : 'primary'"
    :to="{ name: 'notificacoes' }"
  >
    <v-icon :size="isMobile() ? 25 : 33">mdi-bell-outline</v-icon
    ><span v-if="getQtdMsgNaoVisualizadas() > 0" class="badge text-center">{{
      getQtdMsgNaoVisualizadas()
    }}</span>
  </v-btn>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { setIntervalAsync } from "set-interval-async/dynamic";
import { clearIntervalAsync } from "set-interval-async";
export default {
  data: () => ({
    timer: "",
  }),
  methods: {
    ...mapGetters("notificacao", ["getQtdMsgNaoVisualizadas"]),
    ...mapActions("notificacao", ["getNotificacoes"]),
    isMobile() {
      return this.$mq === "sm";
    },
    async cancelAutoUpdate() {
      await clearIntervalAsync(this.timer);
    },
  },
  created() {
    this.getNotificacoes();
    this.timer = setIntervalAsync(async () => {
      await this.getNotificacoes();
    }, 60000);
  },
  beforeDestroy() {
    this.cancelAutoUpdate();
  },
};
</script>

<style scoped>
.badge {
  position: absolute;
  top: -8px;
  right: 7px;
  padding: 1px 3px;
  border-radius: 50%;
  background: orange;
  color: white;
  height: 22px;
  width: 22px;
  font-size: 0.9rem;
}

.nShowUser {
  -webkit-animation: spin 4s backwards infinite;
  -moz-animation: spin 4s linear infinite;
  animation: spin 4s linear infinite;
}
@-moz-keyframes spin {
  100% {
    -moz-transform: rotate(180deg);
  }
}
@-webkit-keyframes spin {
  100% {
    -webkit-transform: rotate(180deg);
  }
}
@keyframes spin {
  100% {
    -webkit-transform: rotate(180deg);
    transform: rotate(180deg);
  }
}
</style>
